import { ButtonSize, Cell, FieldGroupItem, FieldGroupVariant, RadioFieldGroup } from '@dexma/ui-components';
import withLoading from 'adapter/in/common/hoc/withLoading';
import { StyledRowWidgetType } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/style';
import { StyledFeaturePreset, StyledPanelMain } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Main/style';
import i18n from 'asset/translation';
import Branding from 'domain/entity/branding';
import React, { memo } from 'react';
import { FeaturePresetCombo, PanelMainData, PanelWidgetsType, PanelWidgetType } from 'adapter/in/common/widget/WidgetTypePreset/types';

export type PanelMainProps = {
    data: PanelMainData;
    onWidgetClick: (widget: PanelWidgetType) => void;
    onFeaturePresetClick: (preset: any) => void;
    branding?: Branding;
};

export const compareAscFeature = (a: FeaturePresetCombo, b: FeaturePresetCombo): number => {
    const featureTextA = a.text.toUpperCase();
    const featureTextB = b.text.toUpperCase();
    return featureTextA.localeCompare(featureTextB);
};

const PanelMain = (props: PanelMainProps) => {
    const { data, onWidgetClick, onFeaturePresetClick, branding } = props;

    return (
        <StyledPanelMain fluid data-testid='panel-main'>
            <h3 className='mainTitle'>{i18n.t('widgets.widgetMenu.mainDataSourceTitle')}</h3>
            {data.featurePresetCombo.sort(compareAscFeature).map((featurePresetcomboElement: FeaturePresetCombo) => (
                <StyledFeaturePreset
                    branding={branding}
                    key={featurePresetcomboElement.text}
                    $isSelected={featurePresetcomboElement.isSelected}
                    onClick={() => {
                        onFeaturePresetClick(featurePresetcomboElement);
                    }}
                >
                    <span>{featurePresetcomboElement.text}</span>
                </StyledFeaturePreset>
            ))}
            <h3 className='mainTitleWidget'>{i18n.t('widgets.widgetMenu.mainWidgetTypeTitle')}</h3>
            {data.fieldGroupWidgets.map((widget: PanelWidgetsType, index) => (
                <StyledRowWidgetType alignItems='start' key={index}>
                    <Cell className='widget-type-block'>
                        <h3 className='secondaryTitle'>{widget.name}</h3>
                        <RadioFieldGroup
                            variant={FieldGroupVariant.CUSTOM}
                            size={ButtonSize.LARGE}
                            name={widget.name.replace(' ', '_').toLowerCase()}
                            values={widget.values}
                            onChange={(item: FieldGroupItem) => onWidgetClick(item as PanelWidgetType)}
                            onFieldClick={(item: FieldGroupItem) => {
                                if (widget.selectedValue === item.id) onWidgetClick(item as PanelWidgetType);
                            }}
                            selectedValues={widget.selectedValue && widget.selectedValue}
                        />
                    </Cell>
                </StyledRowWidgetType>
            ))}
        </StyledPanelMain>
    );
};

export default memo(withLoading(PanelMain));
